import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RolesPermissionsEffects } from './roles-permissions.effects';
import { rolesPermissionReducer, ROLES_PERMISSION_KEY } from './roles-permissions.reducer';


@NgModule({
    imports: [
        StoreModule.forFeature(ROLES_PERMISSION_KEY, rolesPermissionReducer),
        EffectsModule.forFeature([RolesPermissionsEffects])
    ],
})
export class RolesPermissionsModule { }
